import { useMutation } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { httpClient, ROOT_URL } from '../App';

export type PrintStatementReportBody = {
  startDate: string;
  endDate: string;
  showAllBalances: boolean;
};

export type PrintStatementReportVariables = {
  userId: number;
  body: PrintStatementReportBody;
};

/** API JSON body: `{ data: { url } }` (axios `response.data`) */
export type PrintStatementReportResponseData = {
  data: {
    url: string;
  };
};

export type PrintStatementReportResponse = AxiosResponse<PrintStatementReportResponseData>;

export const usePrintStatementReport = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: printStatementReport,
  });
};

export function printStatementReport({ userId, body }: PrintStatementReportVariables) {
  return httpClient.post<PrintStatementReportResponseData>(
    `${ROOT_URL}/api/v1/period-balances/users/${userId}/generate-report`,
    body,
  );
}
